// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_wrk_ctx_proc = require("./MM_wrk_ctx_proc.bs.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.bs.js");

var procName = "MM_wrk_search_asrt";

function reqToStr(req) {
  return "FindAssertions(label=\"" + req.label + "\", typ=" + String(req.typ) + ", " + ("pattern=[" + req.pattern.map(function (prim) {
                  return String(prim);
                }).join(", ") + "])");
}

function respToStr(resp) {
  if (resp.TAG === /* OnProgress */0) {
    return "OnProgress(pct=" + String(resp._0) + ")";
  } else {
    return "SearchResult";
  }
}

function frameMatchesPattern(frm, pat) {
  var patLen = pat.length;
  var asrtLen = frm.asrt.length;
  var pIdx = 0;
  var aIdx = 0;
  while(pIdx < patLen && aIdx < asrtLen) {
    if (Caml_array.get(frm.asrt, aIdx) < 0 && Caml_array.get(frm.asrt, aIdx) === Caml_array.get(pat, pIdx) || Caml_array.get(frm.asrt, aIdx) >= 0 && Caml_array.get(frm.varTypes, Caml_array.get(frm.asrt, aIdx)) === Caml_array.get(pat, pIdx)) {
      pIdx = pIdx + 1 | 0;
    }
    aIdx = aIdx + 1 | 0;
  };
  return pIdx === patLen;
}

function searchAssertions(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, label, typ, pattern, onProgress) {
  return Expln_utils_promise.promise(function (resolve) {
              MM_wrk_ctx_proc.beginWorkerInteractionUsingCtx(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, procName, /* FindAssertions */{
                    label: label.toLowerCase(),
                    typ: typ,
                    pattern: pattern
                  }, (function (resp, param, endWorkerInteraction) {
                      if (resp.TAG === /* OnProgress */0) {
                        return Curry._1(onProgress, resp._0);
                      }
                      Curry._1(endWorkerInteraction, undefined);
                      Curry._1(resolve, resp.found);
                    }), false, undefined);
            });
}

function doSearchAssertions(wrkCtx, frms, label, typ, pattern, onProgress, param) {
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined, undefined);
  var framesProcessed = {
    contents: 0
  };
  var numOfFrames = Belt_MapString.size(frms);
  var results = [];
  var framesInDeclarationOrder = Belt_MapString.valuesToArray(frms).sort(function (a, b) {
        return a.frame.ord - b.frame.ord | 0;
      });
  framesInDeclarationOrder.forEach(function (frm) {
        var frame = frm.frame;
        if (frame.label.toLowerCase().includes(label) && Caml_array.get(frame.asrt, 0) === typ && frameMatchesPattern(frame, pattern)) {
          var newDisj = MM_context.disjMake(undefined);
          Belt_MapInt.forEach(frame.disj, (function (n, ms) {
                  Belt_SetInt.forEach(ms, (function (m) {
                          MM_context.disjAddPair(newDisj, n, m);
                        }));
                }));
          var newDisjStr = [];
          MM_context.disjForEachArr(newDisj, (function (disjArr) {
                  newDisjStr.push(MM_context.frmIntsToStrExn(wrkCtx, frame, disjArr));
                }));
          var stmts = [];
          var argLabels = [];
          frame.hyps.forEach(function (hyp) {
                if (hyp.typ !== /* E */1) {
                  return ;
                }
                var argLabel = hyp.label;
                argLabels.push(argLabel);
                stmts.push({
                      label: argLabel,
                      expr: hyp.expr,
                      exprStr: MM_context.frmIntsToStrExn(wrkCtx, frame, hyp.expr),
                      jstf: undefined,
                      isProved: false
                    });
              });
          stmts.push({
                label: frame.label,
                expr: frame.asrt,
                exprStr: MM_context.frmIntsToStrExn(wrkCtx, frame, frame.asrt),
                jstf: {
                  args: argLabels,
                  label: frame.label
                },
                isProved: false
              });
          results.push({
                newVars: Belt_Array.range(0, frame.numOfVars - 1 | 0),
                newVarTypes: frame.varTypes,
                newDisj: newDisj,
                newDisjStr: newDisjStr,
                stmts: stmts
              });
        }
        framesProcessed.contents = framesProcessed.contents + 1;
        MM_progress_tracker.progressTrackerSetCurrPct(progressState, framesProcessed.contents / numOfFrames);
      });
  return results;
}

function processOnWorkerSide(req, sendToClient) {
  var results = doSearchAssertions(MM_wrk_ctx_proc.getWrkCtxExn(undefined), MM_wrk_ctx_proc.getWrkFrmsExn(undefined), req.label, req.typ, req.pattern, (function (pct) {
          Curry._1(sendToClient, {
                TAG: /* OnProgress */0,
                _0: pct
              });
        }), undefined);
  Curry._1(sendToClient, {
        TAG: /* SearchResult */1,
        found: results
      });
}

exports.procName = procName;
exports.doSearchAssertions = doSearchAssertions;
exports.searchAssertions = searchAssertions;
exports.processOnWorkerSide = processOnWorkerSide;
exports.frameMatchesPattern = frameMatchesPattern;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
/* MM_context Not a pure module */
